<template>
  <section class="atom-structured-text">
    <section ref="editor" v-if="value">
    </section>
  </section>
</template>

<script>
import Quill from 'quill';

export default {
  name: 'AtomStructuredText',
  props: ['value', 'cid', 'edit'],
  data() {
    return {
      unique: Math.floor(Math.random() * Math.floor(100000)),
      toEdit: false,
      test: null,
      dialogVisible: false,
      hasLink: false,
      addLinkVisible: false,

      hasPopin: false,
      popinStyle: { top: 0, left: 0 },

      fontSizes: [
        { label: 'Titre', value: '200%' },
        { label: 'Sous-titre', value: '150%' },
        { label: 'Texte', value: '100%' },
        { label: 'Petit texte', value: '70%' },
      ],
      link: '',

      Quill,
    };
  },
  mounted() {
    this.init();

    const editor = new Quill(this.$refs.editor, {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ list: 'bullet' }],
          ['clean'],
          ['video'],
        ],
      },
      theme: 'snow',
    });

    editor.setContents(this.value.text);

    editor.on('text-change', () => {
      this.$emit('input', {
        text: editor.getContents(),
      });
    });
  },
  destroy() {
    document.removeEventListener(this.onSelect());
  },
  methods: {
    init() {
      // this.$set(this.value, 'text', this.value.text || 'Texte');
      // this.$set(this.value, 'style', this.value.style || {});
      // this.$set(this.value, 'meta', this.value.meta || '');
      // this.$set(this.value.style, 'textAlign', this.value.style.textAlign || 'center');
      // this.$set(this.value.style, 'color', this.value.style.color || '#222222');
      // this.$set(this.value.style, 'fontSize', this.value.style.fontSize || '100%');

      // this.$el.lastChild.lastChild.innerHTML = this.value.text;
    },
    updateValue(event) {
      this.$emit('input', {
        text: event.target.innerHTML,
        style: this.value.style,
      });
    },
    toggleEdit() {
      this.toEdit = !this.toEdit;
    },
    command(c) {
      document.execCommand(c, false, null);
    },
    checkSelection() {
      const s = document.getSelection();
      let contentEditable = s;
      if (s.baseNode) contentEditable = s.baseNode.parentElement.closest('div[contenteditable]');

      if (contentEditable && s.type === 'Range' && contentEditable.id === `contenteditable${this.cid}`) {
        const x = s.getRangeAt(0).getBoundingClientRect().x - contentEditable.getBoundingClientRect().x;
        const y = s.getRangeAt(0).getBoundingClientRect().y - contentEditable.getBoundingClientRect().y;
        this.hasPopin = true;
        this.popinStyle.top = `${y}px`;
        this.popinStyle.left = `${x}px`;
      } else {
        this.hasPopin = false;
      }
    },
  },
};
</script>

<style lang="sass">
.atom-structured-text
  padding: 0.7rem 0.4rem

  .ql-toolbar
    background: white
    border-radius: 3px 3px 0 0
    border-color: #dcdfe6
  .ql-container
    background: white
    border-radius: 0 0 3px 3px
    border-color: #dcdfe6

  .ql-editor
    min-height: 150px

  // div[contenteditable]
  //   padding: 0
  //   &:focus
  //     outline: 0

  .text-container
    position: relative

  .popin
    position: absolute
    margin-top: 0px
    padding: 0.1rem 0 0.05rem
    width: 92px
    background: #ff3c48
    border-radius: 2px
    transform: translateX(-50px) translateY(100%)
    z-index: 1500
    &:after
      content: ""
      position: absolute
      top: -6px
      left: 50%
      margin-left: -7px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 10px 10px 10px
      border-color: transparent transparent #ff3c48 transparent
      transform: rotate(15deg)
    button
      margin: 0
      padding: 0.4rem 0.5rem
      background: transparent
      color: white
      border: none
      border-radius: 0
      & ~ button
        border-left: 1px solid white
      i
        font-size: 0.85rem

</style>
